import React, {FC, PropsWithChildren} from 'react';

import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Avatar, AvatarProps} from './avatar';
import {AvatarBackground} from './avatarBackground';
import {AvatarHover} from './avatarHover';
import {AvatarInitials} from './avatarInitials';

/*
 * Props.
 */

interface ColorTeammateAvatarProps extends AvatarProps {
  initials: string;
  color: PaletteColorsEnum;
  isFaded?: boolean;
  supportsHover?: boolean;
  hasDarkerHover?: boolean;
}

/*
 * Component.
 */

export const ColorTeammateAvatar: FC<PropsWithChildren<ColorTeammateAvatarProps>> = (props) => {
  const theme = useUserTheme();

  return (
    <Avatar {...props}>
      <AvatarBackground
        color={theme.avatar.findTeammateBackground(theme, props.color)}
        isFaded={props.isFaded}
      />
      <AvatarInitials size={props.size} textColor={theme.invertedText} value={props.initials} />
      {props.supportsHover && <AvatarHover isDarker={props.hasDarkerHover} />}
      {props.children}
    </Avatar>
  );
};
